export default {
  menuItem: {
    account: '賬戶信息',
    billing: '賬單設置',
    appearance: '界面設置',
    organization: '機構管理',
    logout: '退出登錄',
  }
}